package kz.dentalcrm.app.screens.menu.mvi

data class MenuViewState(
    val isLoggingOut: Boolean = false,
)
